import { Range } from "@pdfking/tfunc"

import { LOREM_WORDS } from "#constants"
import type { RandomStream } from "#internal"

import { RandomPick } from "../random/RandomPick"
import { Capitalize } from "./Capitalize"

// One lorem sentence of `count` words: a capital, a full stop
export const LoremSentence = (random: RandomStream, count: number): string =>
  `${Capitalize([...Range(1, count)].map(() => RandomPick(random, LOREM_WORDS)).join(" "))}.`
